/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import AuthenticatedAppLayout from './components/layout/AuthenticatedAppLayout';
import SkeletonLoader from './components/common/SkeletonLoader';
import { AuthPage } from './components/auth/AuthPage';

const DashboardView = lazy(() => import('./views/dashboard/DashboardView'));
const SessionView = lazy(() => import('./views/session/SessionView'));
const ForgotPasswordView = lazy(() => import('./views/auth/ForgotPasswordView'));
const ResetPasswordView = lazy(() => import('./views/auth/ResetPasswordView'));
const ActivationView = lazy(() => import('./views/auth/ActivationView'));
const SettingsView = lazy(() => import('./views/settings/SettingsView'));

/**
 * Main application router configuration.
 */
export const router = createBrowserRouter([
  {
    path: '/login',
    element: <AuthPage />,
  },
  {
    path: '/forgot-password',
    element: (
      <Suspense fallback={<SkeletonLoader type="page" />}>
        <ForgotPasswordView />
      </Suspense>
    ),
  },
  {
    path: '/reset-password',
    element: (
      <Suspense fallback={<SkeletonLoader type="page" />}>
        <ResetPasswordView />
      </Suspense>
    ),
  },
  {
    path: '/activate',
    element: (
      <Suspense fallback={<SkeletonLoader type="page" />}>
        <ActivationView />
      </Suspense>
    ),
  },
  {
    element: <AuthenticatedAppLayout />,
    children: [
      {
        path: '/',
        element: (
          <Suspense fallback={<SkeletonLoader type="page" />}>
            <DashboardView />
          </Suspense>
        ),
      },
      {
        path: '/session/:agentName',
        element: (
          <Suspense fallback={<SkeletonLoader type="page" />}>
            <SessionView />
          </Suspense>
        ),
      },
      {
        path: '/session/id/:sessionId',
        element: (
          <Suspense fallback={<SkeletonLoader type="page" />}>
            <SessionView />
          </Suspense>
        ),
      },
      {
        path: '/settings',
        element: (
          <Suspense fallback={<SkeletonLoader type="page" />}>
            <SettingsView />
          </Suspense>
        ),
      }
    ],
  },

  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);
